import { render, staticRenderFns } from "./DashSimulationList.vue?vue&type=template&id=484bdf15&"
import script from "./DashSimulationList.vue?vue&type=script&lang=js&"
export * from "./DashSimulationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports